module.exports = __webpack_public_path__ + "media/images/favicons/16px-c5e9ebc23c5ac487dc448704e54e865a.png";